//测试服
// export var url = "http://bfthepath.skillbox.cn";
//正式服
// export var url = "http://create.skillbox.cn";
export var url = "http://192.168.0.186:8080";
// export function url() {
//     return "http://bfthepath.skillbox.cn";
//     // return "http://create.skillbox.cn";
//     // return "http://192.168.0.186:8080";
//   }
// const url = "http://create.skillbox.cn"